import { resolveJourneyApplicationNumbers } from './journeyEncryption';
import { getStoredApplicationNumber } from './termJourneyStorage';

export {
  APPLICATION_NUMBER_PLAIN_PATTERN,
  isPlainApplicationNumber,
} from './journeyEncryption';

/**
 * Resolve the plain application number the same way Lead does:
 * decrypt URL/session ciphertext when possible, never treat ciphertext as plain.
 *
 * @param {...*} candidates - Redux value, URL param, leadFormData field, etc.
 * @returns {string|null}
 */
export const getEffectiveApplicationNumber = (...candidates) => {
  for (const candidate of candidates) {
    if (candidate == null || String(candidate).trim() === '') continue;
    const { plain } = resolveJourneyApplicationNumbers(candidate);
    if (plain) return plain;
  }
  return getStoredApplicationNumber();
};
